import { Gpu } from 'lucide-react';

import { useEnvironmentId } from '@/react/hooks/useEnvironmentId';
import { useCurrentEnvironment } from '@/react/hooks/useCurrentEnvironment';
import { PageHeader } from '@/react/components/PageHeader';
import { Widget, WidgetBody, WidgetTitle } from '@/react/components/Widget';
import { GpuSummary } from '@/react/kubernetes/cluster/ClusterView/GpuWidget/GpuSummary';
import { GpuNodesDatatable } from '@/react/kubernetes/cluster/ClusterView/GpuWidget/GpuNodesDatatable';
import { GpuWorkloadsDatatable } from '@/react/kubernetes/cluster/ClusterView/GpuWidget/GpuWorkloadsDatatable';
import { useGpuQuery } from '@/react/kubernetes/cluster/ClusterView/GpuWidget/queries/useGpuQuery';

export function GpuView() {
  const environmentId = useEnvironmentId();
  const { data: environment } = useCurrentEnvironment();
  const { data: gpuInfo, isLoading } = useGpuQuery(environmentId);

  return (
    <>
      <PageHeader
        title="GPU"
        breadcrumbs={[
          { label: 'Environments', link: 'portainer.endpoints' },
          {
            label: environment?.Name || '',
            link: 'portainer.endpoints.endpoint',
            linkParams: { id: environment?.Id },
          },
          'GPU',
        ]}
        reload
      />

      <div className="row">
        <div className="col-sm-12">
          <Widget>
            <WidgetTitle icon={Gpu} title="GPU" />
            <WidgetBody>
              {isLoading ? (
                <div>Loading GPU information...</div>
              ) : (
                gpuInfo && <GpuSummary summary={gpuInfo.Summary} />
              )}
            </WidgetBody>
          </Widget>
        </div>
      </div>

      <div className="row">
        <GpuNodesDatatable nodes={gpuInfo?.Nodes ?? []} isLoading={isLoading} />
      </div>

      <div className="row">
        <GpuWorkloadsDatatable
          workloads={gpuInfo?.Workloads ?? []}
          isLoading={isLoading}
        />
      </div>
    </>
  );
}
